import FlexiText from "slotworks/graphics/elements/flexi-text";
import Layers from "slotworks/graphics/layers/layers";
import Currency from "slotworks/i18n/currency";
import Translations from "slotworks/i18n/translations";

export default class FooterComponent {
    public static layer: Layers = null;

    private text: FlexiText;

    constructor() {
        this.refresh();
        this.showDefaultText();

        if (FooterComponent.layer === null) {
            FooterComponent.layer = Layers.MatrixBackground;
        }

        FooterComponent.layer.onSceneEnter.add(() => this.refresh());
    }

    public showBlank() {
        this.setText("");
    }

    public showNoWin() {
        this.setText(Translations.get("fot.no"));
    }

    public showSpinStart(betValue: number) {
        this.setText(Translations.get("fot.pla", {bet: Currency.format(betValue)}));
    }

    public showFreespinStart() {
        const id = "fot.fpl";
        const message = Translations.get(id);

        if (id !== message) {
            this.setText(message);
        }
    }

    public showGameWin(winValue: number) {
        this.setText(Translations.get("fot.gam", {win: Currency.format(winValue)}));
    }

    public showLineWin(lineValue: number, winValue: number, symbol?: string, matches?: number) {
        const win = Currency.format(winValue);
        this.setText(Translations.get("fot.lin", {line: lineValue, linewin: win, win, matches, symbol}));
    }

    public showFreeSpinsTriggered(freespinsWon?: number) {
        const id = "fot.fre";
        const message = Translations.get(id, {freespins: freespinsWon});

        if (id !== message) {
            this.setText(message);
        }
    }

    public showFreeSpinsRetriggered(freespinsWon?: number) {
        const id = "fot.ret";
        const message = Translations.get(id, {freespins: freespinsWon, SPINS: freespinsWon});

        if (id !== message) {
            this.setText(message);
        }
    }

    public showCustomMessage(message: string) {
        this.setText(message);
    }

    public showDefaultText() {
        this.setText(Translations.get("fot.new"));
    }

    private refresh() {
        if (FooterComponent.layer === null) {
            FooterComponent.layer = Layers.MatrixBackground;
        }

        this.text = FooterComponent.layer.getFlexiText("WelcomeText");
    }

    private setText(text: string) {
        if (this.text) {
            this.text.setText(text);
        }
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/components/info/footer-component.ts